import React from 'react'
import {BsLinkedin} from 'react-icons/bs'

const HeaderLeft = () => {
    return (
        <div className="header_socialsLeft">
            <a href="https://linkedin.com/in/abiodun-olonade" target="_blank" rel="noopener noreferrer"><BsLinkedin /></a>
        </div>
    )
}

export default HeaderLeft